import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbCardModule, NbIconModule } from '@nebular/theme';
import { CreditLimitModalComponent } from './credit-limit-modal.component';

@NgModule({
  declarations: [CreditLimitModalComponent],
  imports: [CommonModule, NbCardModule, NbButtonModule, NbIconModule],
  exports: [CreditLimitModalComponent],
})
export class CreditLimitModalModule {}
